import CheckboxInput from 'shared/components/input/CheckboxInput';
import TimeSelectInput from 'shared/components/input/TimeSelectInput';
import { getText } from 'shared/utils/Text';

const PublishTimePicker = ({
  userEmployer,
  isPublished,
  setIsPublished,
  publishDate,
  nowMoment,
  disabled,
  onPublishDateChange,
}) => (
  <>
    <div className="fgrid fgrid--dialog-form fgrid-dialog-form-wide-labels fgrid--spelvarde-published">
      <div className="fgrid-cell fgrid-cell-label">
        {getText('dialog-bet-config-is-published')} {userEmployer}
      </div>
      <div className="fgrid-cell fgrid-cell-field">
        <CheckboxInput
          disabled={disabled}
          checked={isPublished}
          onChange={evt => setIsPublished(evt.target.checked)}
          colorFill
        />
      </div>
    </div>

    <div className="fgrid fgrid--dialog-form fgrid-dialog-form-wide-labels fgrid--spelvarde-date">
      <div className="fgrid-cell fgrid-cell-label">
        {getText('dialog-bet-config-month')}
      </div>
      <div className="fgrid-cell fgrid-cell-field">
        <TimeSelectInput
          disabled={disabled}
          unit="month"
          selectedMomentDate={publishDate}
          disableBeforeMomentDate={nowMoment}
          width="80"
          onChange={onPublishDateChange}
        />
      </div>

      <div className="fgrid-cell fgrid-cell-label">
        {getText('dialog-bet-config-date')}
      </div>
      <div className="fgrid-cell fgrid-cell-field">
        <TimeSelectInput
          disabled={disabled}
          unit="date"
          width="80"
          selectedMomentDate={publishDate}
          disableBeforeMomentDate={nowMoment}
          onChange={onPublishDateChange}
        />
      </div>

      <div className="fgrid-cell fgrid-cell-label">
        {getText('dialog-bet-config-time')}
      </div>
      <div className="fgrid-cell fgrid-cell-field">
        <TimeSelectInput
          disabled={disabled}
          unit="hour"
          width="80"
          className="inline-dropdown"
          selectedMomentDate={publishDate}
          disableBeforeMomentDate={nowMoment}
          onChange={onPublishDateChange}
        />
        {': '}
        <TimeSelectInput
          disabled={disabled}
          unit="minute"
          width="80"
          className="inline-dropdown"
          selectedMomentDate={publishDate}
          disableBeforeMomentDate={nowMoment}
          onChange={onPublishDateChange}
        />
      </div>
    </div>
  </>
);

export default PublishTimePicker;
